export const compareString = (sortType: string, firstData?: string, secondData?: string) => {
    const isAsc: number = sortType === "asc" ? 1 : -1;
    // 大文字と小文字を区別しない
    const compareFirstData = firstData ? firstData.toUpperCase() : "";
    const compareSecondData = secondData ? secondData.toUpperCase() : "";

    if (compareFirstData && compareSecondData){
        if (compareFirstData > compareSecondData){
            return isAsc;
        } else  if (compareFirstData < compareSecondData){
            return -isAsc;
        } else {
            return 0;
        }
    // 比較対象文字列が空文字の場合、後ろへ
    } else if(!compareFirstData && compareSecondData) {
        return 1;
    } else if(compareFirstData && !compareSecondData) {
        return -1;
    } else {
        return 0;
    }
};
